import { useApolloClient } from "@apollo/client";
import { WebPubSubClient } from "@azure/web-pubsub-client";
import { useCallback, useEffect } from "react";

interface UseCacheEvictParams
{
  getClientAccessUrl: () => Promise<string>;
  groupName: string;
  queryName: string;
  onEvict?: () => void;
}

let wsClient: WebPubSubClient | null = null;
let url: string | null = null;
const groupMembership: Record<string, boolean> = {}; // kulcs: groupName
let init = false;


export function useCacheEvict({
  getClientAccessUrl,
  groupName,
  queryName,
  onEvict,
}: UseCacheEvictParams): { joinGroup: () => Promise<void> }
{
  const client = useApolloClient();

  useEffect(() =>
  {
    if(init) return;
    init = true;
    (async () =>
    {
      if(wsClient) return;
      url = await getClientAccessUrl();
      if(!url) return;
      wsClient = new WebPubSubClient(url);
      wsClient.on("group-message", handleGroupMessage);
      if(!groupMembership[groupName])
      {
        wsClient.joinGroup(groupName);
        groupMembership[groupName] = true;
      }
      wsClient.start();
    })();
    return () =>
    {
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const joinGroupAgain = useCallback(async () =>
  {
    if(!wsClient) return;
    if(!groupMembership[groupName])
    {
      await wsClient.joinGroup(groupName);
      groupMembership[groupName] = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGroupMessage = useCallback(async () =>
  {
    if(!wsClient) return;
    client.cache.evict({ fieldName: queryName });
    client.cache.gc();
    if(onEvict)
    {
      onEvict();
      return;
    }
    const key = groupName;
    if(groupMembership[key])
    {
      await wsClient.leaveGroup(groupName);
      groupMembership[key] = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { joinGroup: joinGroupAgain };
}
